import React, {useState} from 'react';
import {useQuery} from 'react-query';
import {getQuestionCategory} from '../../../../services/questionSvc';
import CategoryForm from "./components/CategoryForm";
import CategoryTable from "./components/CategoryTable";

export const CategoryCreatePage = () => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);

  const {
    data: questionCategory,
    refetch: refetchQuestionCategory,
    isLoading: questionCategoryIsLoading,
    isError: questionCategoryIsError,
  } = useQuery('getQuestionCategory', getQuestionCategory);

  const handleEditClick = (id: number) => {
    setSelectedCategoryId(id);
  };

  return (
      <div>
        <CategoryForm
            selectedCategoryId={selectedCategoryId}
            setSelectedCategoryId={setSelectedCategoryId}
            refetchQuestionCategory={refetchQuestionCategory}
        />
        <CategoryTable
            questionCategory={questionCategory}
            questionCategoryIsLoading={questionCategoryIsLoading}
            questionCategoryIsError={questionCategoryIsError}
            refetchQuestionCategory={refetchQuestionCategory}
            handleEditClick={handleEditClick}
        />
      </div>
  );
};